var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #00a9a9;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #00a9a9;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 600,
    cy: 600.34,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 597.14,
    y1: 166.32,
    x2: 597.14,
    y2: 1056.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "383.1 720.86 383.1 573.17 803.05 573.17 870.47 647.01 803.05 720.86 383.1 720.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "811.18 312.03 811.18 459.72 391.23 459.72 323.81 385.87 391.23 312.03 811.18 312.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 597.14,
    cy: 163.04,
    r: 39.97
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.075fca4df361af1ed4fb52e4250b9aa8.svg";
export { ForwardRef as ReactComponent };